import { render, staticRenderFns } from "./PollMatrixEditorItem.vue?vue&type=template&id=67f3e35b&scoped=true"
import script from "./PollMatrixEditorItem.vue?vue&type=script&lang=js"
export * from "./PollMatrixEditorItem.vue?vue&type=script&lang=js"
import style0 from "./PollMatrixEditorItem.vue?vue&type=style&index=0&id=67f3e35b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f3e35b",
  null
  
)

export default component.exports